'use client';

import { Plus } from 'lucide-react';
import {
  InternalNotesProvider,
  useInternalNotesContext,
} from 'src/shared/components/internal-notes/InternalNotesContext';
import NoteList from 'src/shared/components/internal-notes/NoteList';
import NoteCompose from 'src/shared/components/internal-notes/NoteCompose';

type InternalNotesTabProps = {
  integrationId: string;
  threadId: string;
  isComposing?: boolean;
  onComposingChange?: (composing: boolean) => void;
  showComposeButton?: boolean;
};

function ComposeButton() {
  const { setIsComposing } = useInternalNotesContext();

  return (
    <button
      onClick={() => setIsComposing(true)}
      className="flex items-center justify-center gap-2 w-full px-4 py-2 bg-white border border-border rounded-[3px] text-sm font-semibold text-typography-black hover:bg-muted transition-colors"
    >
      <Plus size={16} />
      New internal note
    </button>
  );
}

export default function InternalNotesTab({
  integrationId,
  threadId,
  isComposing,
  onComposingChange,
  showComposeButton = true,
}: InternalNotesTabProps) {
  return (
    <InternalNotesProvider
      integrationId={integrationId}
      threadId={threadId}
      isComposing={isComposing}
      onComposingChange={onComposingChange}
    >
      <div className="flex flex-col h-full">
        <div className={`flex-1 overflow-y-auto ${showComposeButton ? 'p-4' : ''}`}>
          <div className="flex flex-col gap-4">
            {showComposeButton && <ComposeButton />}
            <NoteList />
            <NoteCompose />
          </div>
        </div>
      </div>
    </InternalNotesProvider>
  );
}
